import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // your global styles / tailwind import lives in here
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./api/queryClient";
import { initGtag } from "./initGtag";
import { RoleTestProvider } from "@common";

initGtag();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RoleTestProvider>
        <App />
        {process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} />}
      </RoleTestProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
